export default "/_next/static/chunks/fonts/Raleway Light-ef9d219858bb2970f9ccdacbceb65221.ttf";